import { render, staticRenderFns } from "./AuctionColumn.vue?vue&type=template&id=8c90a738&scoped=true&"
import script from "./AuctionColumn.vue?vue&type=script&lang=ts&"
export * from "./AuctionColumn.vue?vue&type=script&lang=ts&"
import style0 from "./AuctionColumn.vue?vue&type=style&index=0&id=8c90a738&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c90a738",
  null
  
)

export default component.exports